export enum CatalogMenuLabelEnum {
    YOUR_PROGRAMS = 'Your programs',
    YOUR_FORMATS = 'Your formats',
}
